module.exports = __webpack_public_path__ + "static/img/newsPic4.47c8951.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsPic4.png
// module id = cO5G
// module chunks = 1